module.exports = __webpack_public_path__ + "static/media/a2.25e55b61.jpeg";